"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _urlJwtConvertor = require("@airasia-common/url-jwt-convertor");

var _constants = require("./constants");

var _EnvironmentUrl = _interopRequireDefault(require("../../config/environment/EnvironmentUrl"));

function createJwtTokenProvider(environment) {
  var ssrDataUrl = _EnvironmentUrl["default"][environment].HOTELS_SSR_DATA_URL;
  var tokenConvertor = new _urlJwtConvertor.UrlToJWT(ssrDataUrl, _constants.JWT_HASH, _constants.SSR_DATA);
  var tokens = {};

  var getToken = function getToken() {
    var endpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.DEFAULT_ENDPOINT;

    if (tokens[endpoint]) {
      return Promise.resolve(tokens[endpoint]);
    }

    return tokenConvertor.getToken(endpoint);
  };

  return {
    getToken: getToken
  };
}

var _default = createJwtTokenProvider;
exports["default"] = _default;